import type { EpcExtractionData } from "features/dt-basic-setup/single-building/components/address-step/epc-modal/types";

import { Stack } from "@mui/material";
import { SuccessCheckmarkIcon } from "components/IconsTextsUtils";
import { Message } from "components/Message";
import {
  buildEpcAdditionalSections,
  buildEpcPrefillRows,
} from "features/dt-basic-setup/single-building/lib/epcPreviewRows";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { EpcBackButton } from "./EpcBackButton";
import { EpcAdditionalSectionsCard } from "./preview/EpcAdditionalSectionsCard";
import { EpcDataRow } from "./preview/EpcDataRow";

type EpcreviewContentProps = {
  epcData: EpcExtractionData;
  fileExtension?: string;
  onBack?: () => void;
};

export const EpcPreviewPhase = ({ epcData, fileExtension, onBack }: EpcreviewContentProps) => {
  const { t } = useTranslation();
  const prefillRows = useMemo(() => buildEpcPrefillRows(epcData, t), [epcData, t]);
  const additionalSections = useMemo(() => buildEpcAdditionalSections(epcData, t), [epcData, t]);
  const badgeLabel = (fileExtension ?? "").replace(".", "").toUpperCase();
  return (
    <Stack className="w-full flex-1 flex-col overflow-y-auto pr-1">
      <Stack className="w-full flex-col items-stretch gap-8 text-left">
        <Stack className="w-full justify-between gap-4">
          <Stack className="min-w-0 gap-4">
            <EpcBackButton onBack={onBack} />
            <h2 className="font-ds-headline-lg text-left">{t("AddBuilding.epcModal.preview.title")}</h2>
          </Stack>
          <span className="rounded-ds-0-25x px-2 py-1 text-lds-link-primary font-ds-body-bold-xs">{badgeLabel}</span>
        </Stack>
        <Stack className="w-full flex-col items-stretch gap-5 rounded-ds-0-75x border bg-lds-surface-success-softest p-5">
          <Stack className="w-full gap-1">
            <SuccessCheckmarkIcon />
            <Message
              className="font-ds-body-bold-md"
              message={t("AddBuilding.epcModal.preview.prefillTitle")}
              variant="success"
            />
          </Stack>
          <Stack className="w-full flex-col items-stretch ">
            {prefillRows.map((row) => (
              <EpcDataRow key={row.label} row={row} />
            ))}
          </Stack>
        </Stack>
        <EpcAdditionalSectionsCard sections={additionalSections} />
      </Stack>
    </Stack>
  );
};
